import abilitiesData from '../../../../config/static_data/abilities.json'
import encounterTimelineData from '../../../../config/static_data/encounter_timeline.json'
import { generalTimelineAbilities } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamPlans/config/generalAbilities'
import { Abilities } from 'app/frontend/types/custom/Abilities'
import { EncounterEvents } from 'app/frontend/types/custom/EncounterEvents'

const abilities = abilitiesData as Abilities
const encounterTimeline = encounterTimelineData as EncounterEvents

export const getRaidPlanAbilities = () => abilities
export const getEncounterTimelineData = () => encounterTimeline
export const getGeneralTimelineAbilities = () => generalTimelineAbilities
